import { createFileRoute } from '@tanstack/react-router';
import { ReportsHub } from '../../../features/reports/screens/ReportsHub';

/** Owned by G25. Reports hub — landing page listing all 12 BUILD_SPEC.md §13
 * reports plus the "browse the data" registers. */
export const Route = createFileRoute('/_authenticated/reports/')({
  component: ReportsHub,
});
